import { useState } from 'react'

import { useFetch } from 'hooks'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { ChurnStepper } from './components'

import * as service from 'service'

const ChurnsEdit = ({ match }) => {
  const {
    params: { churnId },
  } = match

  const [loading, setLoading] = useState(false)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.churns.show,
    { churnId },
    [],
  )

  const churn = response?.data?.churn

  return (
    <Page title="Edição da solicitação de churn">
      <LoadingFeedback open={isLoading || loading} />
      {churn && (
        <Container maxWidth={false}>
          <ContentHeader
            menu="Solicitação de churn"
            title="Edição"
            subtitle="Solicitação de churn"
          />
          <ChurnStepper
            churn={churn}
            setLoading={setLoading}
            refresh={refresh}
          />
        </Container>
      )}
    </Page>
  )
}

export default ChurnsEdit
